import React, { useState } from 'react'
import axios from 'axios'
import { API_URL } from '../settings'
import { useAuth } from '../Hooks/useAuth'

const DataTableRowComponent = ({ row, year, month, fetchData }) => {
    const [ edit, setEdit ] = useState(false)
    const [ leadsTarget, setLeadsTarget ] = useState(row.Leads_target)
    const [ mqlTarget, setMqlTarget ] = useState(row.MQL_target)
    const [ sqlTarget, setSqlTarget ] = useState(row.SQL_target)
    const { user } = useAuth()

    const editRow = () => {
        // Save the data to the server
        const payload = {
            ...row,
            Leads_target: Number(leadsTarget),
            MQL_target: Number(mqlTarget),
            SQL_target: Number(sqlTarget)
        }
        axios.put(`${API_URL}/dashboard/edit-row`, { year, payload}, { headers: { token: user.token, useremail: user.email } })
        .then(() => { 
            setEdit(false)
            fetchData(year, month)    
        }).catch(err => console.log(err))
    }
    
    return (
        <>
            <td className="px-5 py-5 bg-white text-md">
                { row.Leads_achieved }
            </td>
            <td className="px-5 py-5 bg-white text-md text-pinegreen font-bold italic">
                { edit ? <input
                            type='number'
                            className="block w-1/2 mx-auto rounded-md border-0 py-1.5 text-label text-center ring-1 ring-inset ring-pinegreen focus:ring-1 focus:ring-inset focus:ring-mossgreen font-light italic"
                            defaultValue={row.Leads_target} 
                            onChange={e => setLeadsTarget(e.target.value)} 
                        /> : row.Leads_target }
            </td>
            <td className="px-5 py-5 bg-white text-md">
                { row.MQL_achieved }
            </td>
            <td className="px-5 py-5 bg-white text-md text-pinegreen font-bold italic">
                {   edit ? <input 
                                className="block w-1/2 mx-auto rounded-md border-0 py-1.5 text-label text-center ring-1 ring-inset ring-pinegreen focus:ring-1 focus:ring-inset focus:ring-mossgreen font-light italic"
                                defaultValue={row.MQL_target} 
                                onChange={e => setMqlTarget(e.target.value)} 
                            /> : row.MQL_target 
                }
            </td>
            <td className="px-5 py-5 bg-white text-md">
                { row.SQL_achieved }
            </td>
            <td className="px-5 py-5 bg-white text-md text-pinegreen font-bold italic">
                {   edit ? <input
                                className="block w-1/2 mx-auto rounded-md border-0 py-1.5 text-label text-center ring-1 ring-inset ring-pinegreen focus:ring-1 focus:ring-inset focus:ring-mossgreen font-light italic"
                                defaultValue={row.SQL_target}
                                onChange={e => setSqlTarget(e.target.value)}
                            /> : row.SQL_target
                }
            </td>
            <td>
                {
                    edit ? 
                    <>
                        <button title="Save" className="bg-mossgreen text-sm text-white p-1 rounded-full mx-1" onClick={() => editRow()}>✔</button>
                        <button title="Cancel" className="bg-warningError text-sm text-white p-1 rounded-full mx-1" onClick={() => setEdit(false)}>✖</button>
                    </> 
                    : 
                    <button className="bg-pinegreen text-xs text-white px-4 py-1 rounded-lg" onClick={() => setEdit(true)}>Edit</button>
                }
            </td>
        </>
    )
}
export default DataTableRowComponent;